import eSystemControllerTypes from '../eControllerTypes';

export default {
  ERCT_SPINNER: `${eSystemControllerTypes.ECT_RULES}__spinner`,
}
